import { createCtx } from '@/lib/utils/context'

import { Course } from '@/features/Courses/types'

export type CourseContext = Course

export type CourseContextProviderProps = {
  children: React.ReactNode
  value: Course
}

const carouselContext = createCtx<CourseContext>()
const Provider = carouselContext[1]
export const useCourseContext: () => CourseContext = carouselContext[0]

export const CourseContextProvider = ({
  children,
  value,
}: CourseContextProviderProps): React.ReactElement => {
  const contextValue = value

  return <Provider value={contextValue}>{children}</Provider>
}
